module.exports = __webpack_public_path__ + "img/module0.351aeb67.png";